import { render, staticRenderFns } from "./DropdownMenuButtonIcon.vue?vue&type=template&id=758e9766&scoped=true"
import script from "./DropdownMenuButtonIcon.vue?vue&type=script&lang=js"
export * from "./DropdownMenuButtonIcon.vue?vue&type=script&lang=js"
import style0 from "./DropdownMenuButtonIcon.vue?vue&type=style&index=0&id=758e9766&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758e9766",
  null
  
)

export default component.exports